import React from 'react'

export default function WorkersSelectItem({Description, SecondCode}) {
    return (
        <option value={SecondCode}>
            {Description}
        </option>
    )
}
